import React, { useEffect, useState } from "react";
import i18next from "i18next";
import { optionsCallToActionLinkedin } from "../../../../utils/options";
import {
  ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION,
  LINKEDIN_AD_FORMAT_DOCUMENT,
} from "../../../../utils/constants";
import {
  FIELD_REQUIRED,
  ADS_CAMPAIGN_CALL_TO_ACTION_UNLOCK_FULL_DOCUMENT,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import Select from "../../../Form/Select";
import { useController, useFormContext } from "react-hook-form";

// Call to action values allowed for LEADS objective
const LEADS_ALLOWED_CALL_TO_ACTIONS = [
  "SIGN_UP",
  "APPLY",
  "DOWNLOAD",
  "VIEW_QUOTE",
  "LEARN_MORE",
  "SUBSCRIBE",
  "REGISTER",
  "JOIN",
  "ATTEND",
  "REQUEST_DEMO",
];

const SelectCallToActionLinkedin = React.forwardRef(
  function SelectCallToActionLinkedin(props, ref) {
    const {
      control,
      errors,
      rules = {
        required: {
          value: true,
          message: i18next.t(FIELD_REQUIRED),
        },
      },
      name,
      label,
      disabled,
      fullWidth,
      variant = "filled",
      objective,
      adFormat,
      sx = {},
    } = props;

    const [options, setOptions] = useState([]);
    const { t } = useTranslationApp();
    const isDocumentLeadGen =
      adFormat === LINKEDIN_AD_FORMAT_DOCUMENT &&
      objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION;

    const { setValue } = useFormContext();
    const {
      field: { value: fieldValue },
    } = useController({
      control,
      name,
    });

    useEffect(() => {
      if (isDocumentLeadGen) {
        setOptions([
          {
            value: "UNLOCK_FULL_DOCUMENT",
            label: ADS_CAMPAIGN_CALL_TO_ACTION_UNLOCK_FULL_DOCUMENT,
          },
        ]);
        return;
      }

      if (objective === ADS_CAMPAIGN_OBJECTIVE_LEADS_OPTION) {
        setOptions(
          optionsCallToActionLinkedin.filter((option) =>
            LEADS_ALLOWED_CALL_TO_ACTIONS.includes(option.value)
          )
        );
        return;
      }

      setOptions(optionsCallToActionLinkedin);
    }, [objective, adFormat, isDocumentLeadGen]);

    useEffect(() => {
      if (options?.length === 0) return;

      if (!fieldValue) {
        setValue(name, options?.[0].value, { shouldDirty: false });
        return;
      }

      const isValidCallToAction = options.some((o) => o.value === fieldValue);
      if (!isValidCallToAction) {
        setValue(name, options?.[0].value, { shouldDirty: false });
      }

      // eslint-disable-next-line
    }, [fieldValue, options]);

    return (
      <Select
        ref={ref}
        label={t(label)}
        disabled={disabled || isDocumentLeadGen}
        name={name}
        variant={variant}
        options={options}
        fullWidth={fullWidth}
        doTranslate={true}
        control={control}
        errors={errors}
        rules={{
          ...rules,
          validate: (value) => {
            if (!options.map((o) => o.value).includes(value))
              return t(FIELD_REQUIRED);
          },
        }}
        sx={sx}
      />
    );
  }
);

export default SelectCallToActionLinkedin;
